// extracted by mini-css-extract-plugin
module.exports = {"switch":"switch_switch__38CEn","circle":"switch_circle__1RvKq"};